/* eslint-disable no-unused-vars */
import React from "react";
import { Result } from "antd";

const UnauthorizedPage = () => <Result status="warning" title="401" subTitle="抱歉，您無權訪問此頁面。" />;
export default UnauthorizedPage;
